"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNonNullable = isNonNullable;
/**
 * Type guard that checks if variable isn't `null` or `undefined`:
 *
 * ```TypeScript
 * declare const foobar: string | null;
 *
 * if (isNonNullable(foobar)) {
 *   // `typeof foobar` is now `string`
 * } else {
 *   // `typeof foobar` is now `null`
 * }
 * ```
 *
 * @typeParam T Type of `value`
 * @param value Value being checked
 * @return `true` if `value` is non-nullable
 */
function isNonNullable(value) {
  return value != null;
}
//# sourceMappingURL=isNonNullable.js.map